export { ChangePasswordAction } from 'next-flight-server-reference-proxy-loader?id=7f3007d4a8f481367aed4730b0c1491af593fcaaea&name=ChangePasswordAction!'